import { INavigationItemProps } from '../../ui-toolkit';

export const cdBuilderNavigationOptions = (orderId: string): INavigationItemProps[] => [
  {
    text: 'Sections A - J & Payoffs',
    to: `/spa/admin/order/${orderId}/cd_builder/section-a-j`,
  },
  {
    text: 'Sections K, L, M, N',
    to: `/spa/admin/order/${orderId}/cd_builder/section-k-n`,
  },
];
